import { createFileRoute } from "@tanstack/react-router";

import { NamesIndex } from "../components/prenoms/names-index";
import { namesIndexHead } from "../components/prenoms/names-index";
import { namesApi } from "../lib/api";
import { seo } from "../lib/head";

export const Route = createFileRoute("/prenoms/")({
  staticData: { ssr: true },
  loader: async ({ context }) => {
    const [names, years] = await Promise.all([
      context.queryClient.query({
        queryKey: ["prenoms"],
        queryFn: namesApi.index,
        staleTime: "static",
      }),
      context.queryClient.query({
        queryKey: ["prenoms-years"],
        queryFn: namesApi.years,
        staleTime: "static",
      }),
    ]);
    return { names, years };
  },
  head: ({ loaderData }) => (loaderData ? seo(namesIndexHead(loaderData.names.length)) : {}),
  component: Page,
});
function Page() {
  const { names, years } = Route.useLoaderData();
  return <NamesIndex names={names} years={years} />;
}
